import { landingScreen } from './analytics'

function handleType(questionType, answerbyUser) {
    if (questionType === 'SCMCQ') {
        return JSON.parse(answerbyUser).length ? JSON.parse(answerbyUser)[0] : ['']
    }
    if (questionType === 'MATRIX') {
        return JSON.parse(answerbyUser)
    }
    if (questionType === 'SAN' || questionType === 'SAT') {
        if (Array.isArray(JSON.parse(answerbyUser))) {
            return JSON.parse(answerbyUser)
        }
    }
    if (questionType === 'MCMCQ') {
        return JSON.parse(answerbyUser)
    }
    return ''
}

function updateTestDataProps(props, res, res1) {
    let latestStatus = {}
    res1.forEach((item) => {
        latestStatus[item['questionId']] = item
    })
    let sections = []
    res?.sectionList?.forEach((item) => {
        sections.push({
            sectionid: item?.id,
            sectionname: JSON.stringify(item?.title),
        })
    })
    let questions = []
    sections?.forEach((parent, i) => {
        questions.push({
            subject: parent?.sectionname,
            questionList: [],
        })
        res.SectionQuestion.forEach((item, pos) => {
            if (item.sectionId === parent.sectionid) {
                let english_text = 'text'
                let hindi_text
                let gujarati_text
                if (item.question.defaultQuestionLanguage) {
                    english_text =
                        'text' in item.question.defaultQuestionLanguage?.question
                            ? item.question.defaultQuestionLanguage?.question?.text
                            : item.question.defaultQuestionLanguage?.question
                                  ?.question?.text
                }
                if (item.question.hindiQuestionLanguage) {
                    hindi_text =
                        'text' in item.question.hindiQuestionLanguage?.question
                            ? item.question.hindiQuestionLanguage?.question?.text
                            : item.question.hindiQuestionLanguage?.question?.question
                                  ?.text
                }
                if (item.question.gujaratiQuestionLanguage) {
                    gujarati_text =
                        'text' in item.question.gujaratiQuestionLanguage?.question
                            ? item.question.gujaratiQuestionLanguage?.question?.text
                            : item.question.gujaratiQuestionLanguage?.question
                                  ?.question?.text
                }
                let english_answer = {}
                let hindi_answer = {}
                let gujarati_answer = {}
                if (item.question.defaultQuestionLanguage !== null) {
                    english_answer =
                        'question' in item.question.defaultQuestionLanguage
                            ? item.question.defaultQuestionLanguage.question
                            : {}
                }
                if (
                    item.question.hindiQuestionLanguage !== undefined &&
                    item.question.hindiQuestionLanguage !== null
                ) {
                    hindi_answer =
                        'question' in item.question.hindiQuestionLanguage
                            ? item.question.hindiQuestionLanguage.question
                            : {}
                }
                if (
                    item.question.gujaratiQuestionLanguage !== undefined &&
                    item.question.gujaratiQuestionLanguage !== null
                ) {
                    gujarati_answer =
                        'question' in item.question.gujaratiQuestionLanguage
                            ? item.question.gujaratiQuestionLanguage.question
                            : {}
                }
                let english_solution = ''
                let hindi_solution = ''
                let gujarati_solution = ''
                if (
                    item.question.defaultQuestionLanguage !== null &&
                    item.question.defaultQuestionLanguage.solution != undefined &&
                    item.question.defaultQuestionLanguage.solution != null
                ) {
                    english_solution = item.question.defaultQuestionLanguage.solution
                }
                if (
                    item.question.hindiQuestionLanguage !== null &&
                    item.question.hindiQuestionLanguage.solution != undefined &&
                    item.question.hindiQuestionLanguage.solution != null
                ) {
                    hindi_solution = item.question.hindiQuestionLanguage.solution
                }
                if (
                    item.question.gujaratiQuestionLanguage &&
                    item.question.gujaratiQuestionLanguage.solution
                ) {
                    gujarati_solution =
                        item.question.gujaratiQuestionLanguage.solution
                }
                questions[i].questionList.push({
                    qid: pos + 1,
                    question: {
                        questionid: item.questionId,
                        en: english_text,
                        hi: hindi_text,
                        gu: gujarati_text,
                        marks: item.marks,
                        questionType: item.question.questionType,
                        english_answer,
                        hindi_answer,
                        gujarati_answer,
                        english_solution,
                        hindi_solution,
                        gujarati_solution,
                        isAnswered: latestStatus.hasOwnProperty(item.questionId)
                            ? latestStatus[item.questionId].attempted === 1
                                ? true
                                : false
                            : false,
                        answerbyUser: latestStatus.hasOwnProperty(item.questionId)
                            ? handleType(
                                  item.question.questionType,
                                  latestStatus[item.questionId].answer,
                              )
                            : [],
                        isMarkedForReview: latestStatus.hasOwnProperty(
                            item.questionId,
                        )
                            ? latestStatus[item.questionId].markedForReview === 1
                                ? true
                                : false
                            : false,
                        isVisited: latestStatus.hasOwnProperty(item.questionId)
                            ? true
                            : false,
                        answeredAndMarkedForReview: false,
                        isCurrentlyOpened:
                            questions[i].questionList.length === 0 ? true : false,
                        timeSpent: 0,
                        lod: item.question.lod1,
                        questionExternalId: item.question.questionExternalId,
                    },
                })
            }
        })
    })
    const currentQuestion =
        questions[props.active_section].questionList[props.active]
    currentQuestion['subject'] = JSON.parse(questions[props.active_section].subject)
    props.UpdateCurrentQuestion(currentQuestion)
    props.onQuestionLoad(questions)

    const isMock = JSON.parse(sessionStorage.getItem('is_mock'))
    const isPreview =
        sessionStorage.getItem('tp_preview_token') &&
        sessionStorage.getItem('test_id')
            ? true
            : false

    if (isPreview || isMock) return

    landingScreen(props, questions)
}

function updatePropsOnLoad(
    props,
    setIsRedirect,
    setShowGoBackPopUp,
    setConnection,
    setDisconnectTime,
) {
    props.setCorrectOTP(false)

    const isRedirectedFromInstructions = JSON.parse(
        sessionStorage.getItem('isRedirected'),
    )
    const isRedirectedFromAnalytics = JSON.parse(
        sessionStorage.getItem('isRedirectedFromAnalytics') ?? false,
    )
    const isMock = JSON.parse(sessionStorage.getItem('is_mock'))
    const isSubmitted = JSON.parse(sessionStorage.getItem('isSubmitted'))

    if (
        performance.navigation.type === performance.navigation.TYPE_RELOAD &&
        !isRedirectedFromInstructions &&
        !isRedirectedFromAnalytics
    ) {
        setShowGoBackPopUp(true)
    } else {
        sessionStorage.setItem('isRedirectedFromAnalytics', false)
        sessionStorage.setItem('isRedirected', false)
    }

    if (navigator.onLine) {
        if (localStorage.getItem('offline') === 'true') {
            localStorage.setItem('offline', 'false')
            setConnection('online')
        }
    } else {
        localStorage.setItem('offline', 'true')
        setConnection('offline')
    }
    props.hideTimer(isMock && isSubmitted)
    props.setActiveSection(0)
    props.setActive(0)

    const timeLeft =
        (props.test_duration - (props.isExistingTest ? props.resumedData : 0)) * 60
    if (props.isExistingTest && timeLeft <= 0) {
        setIsRedirect(true)
        return
    }
    props.updateTimer(timeLeft).then(() => {
        props.updateCalculatedTimeLeft(timeLeft)
        setDisconnectTime(props.queryparam.disconnect_time * 60)
    })
}

function attachRefreshEventListeners(setShowGoBackPopUp) {
    window.addEventListener(
        'popstate',
        (event) => {
            if (event.state) {
                setShowGoBackPopUp(true)
            }
        },
        false,
    )
    window.history.pushState(
        { name: 'browserBack' },
        'on browser back click',
        window.location.href,
    )
}

export { updateTestDataProps, updatePropsOnLoad, attachRefreshEventListeners }
